import { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';

import initFlashConnect from 'component-utilities/flashMessages/flashConnect';
import initFlashMessages from 'component-utilities/flashMessages/flashMessages';

import {
  setActiveViewId,
  resetFlashView,
} from '../state_managers/FlashMessagesStateManager';

import PAGES from '../constants/Pages';
import { ReduxState } from 'global/types';

export { PAGES };

const flashConnect = initFlashConnect((component: any) =>
  connect(
    null,
    { setActiveViewId, resetFlashView },
  )(component),
);
export { flashConnect };

// Hook form of the flashConnect HOC, for function components: sets the active
// flash view id on mount and resets it on unmount — matching the HOC's
// constructor + registerUnmountCleanupMethod behaviour.
export function useFlashConnect(activeViewId: string, viewName: string) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveViewId(activeViewId));

    return () => {
      dispatch(resetFlashView({ from: viewName }));
    };
  }, [dispatch, activeViewId, viewName]);
}

const FlashMessages = initFlashMessages((component: any) =>
  connect(({ flashMessages }: ReduxState) => ({ flashMessages }))(component),
);
export default FlashMessages;
